import script from "./SessionDetailComponentJanuary13.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionDetailComponentJanuary13.vue?vue&type=script&setup=true&lang=js"

import "./SessionDetailComponentJanuary13.vue?vue&type=style&index=0&id=524fd854&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-524fd854"]])

export default __exports__